import { Field, Label } from "@headlessui/react";
import SimpleListbox, { SimpleOption } from "./SimpleListbox";

interface SelectProps {
	value: string | number | undefined;
	setValue: (value: string | number | undefined) => void;
	simpleListBoxId: string;
	options: SimpleOption[];
	label?: string;
	fieldClasses?: string;
	labelClasses?: string;
	simpleListBoxClasses?: string;
}

export default function Select(props: SelectProps) {
	return (
		<Field className={props.fieldClasses ?? undefined}>
			{props.label && (
				<Label
					htmlFor={props.simpleListBoxId}
					className={`${props.labelClasses ? `${props.labelClasses} ` : ""}block mb-2 text-sm font-medium text-gray-90`}>
					{props.label}
				</Label>
			)}
			<SimpleListbox
				id={props.simpleListBoxId}
				options={props.options}
				value={props.value}
				className={props.simpleListBoxClasses ?? undefined}
				onChange={(e) => props.setValue(e.target.value)}
			/>
		</Field>
	);
}
